import {useTranslationWithOverride} from "components/src/hook/UseTranslationWithOverride";
import {StringUtils} from "components/src/utils/StringUtils";
import {Check as CheckIcon} from "iconoir-react";
import {useState} from "react";
import Button from "react-bootstrap/Button";

export interface CopyToClipboardProps {
    value : string | undefined
}

export const CopyToClipboard = ({value}: CopyToClipboardProps) =>
{
    /**
     * Set to true when a value is copied to the clipboard
     */
    const [copied, setCopied] = useState<boolean>(false);

    /**
     * i18next translation hook
     */
    const {t} = useTranslationWithOverride();

    return (
        <Button
            className="border border-1 d-flex align-items-center"
            variant="light"
            title={t('common.copy-to-clipboard-title')}
            disabled={StringUtils.isBlank(value)}
            onClick={(e) => {
                navigator.clipboard.writeText(value ?? "");
                setCopied(true);
                e.preventDefault()
            }}>
            {t('common.copy')} {copied && <CheckIcon className="text-success ms-2"/>}
        </Button>
    )
};
